module.exports = __webpack_public_path__ + "media/images/kickstarter/sp-74c1b5c9d631ab516c4e0d880a2f86f7.png";